// extracted by mini-css-extract-plugin
export var gif = "_df-0";